import { isMobile, Modal } from '@triumph/design-system';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
    DocumentInfo,
    DocumentPreview,
    FileNameDiv,
    Header,
} from './ViewDocumentModal.StyledComponents';
import { ViewDocumentModalProps } from './ViewDocumentModal.types';
import { useAppContext } from '@/app/components/providers/AppContextProvider';
import PdfPreview from '../PdfPreview';

const ViewDocumentModal: FC<ViewDocumentModalProps> = ({
    filename,
    url,
    isViewModalOpen,
    handleClose,
    customHeaderContent,
    isPdfPreview,
}: ViewDocumentModalProps) => {
    const { breakpoint } = useAppContext();

    const { t } = useTranslation('invoicesDashboard');

    const modalBodyContent = (
        <>
            {isPdfPreview ? (
                <PdfPreview url={url} />
            ) : (
                <DocumentPreview data-testid="document-preview-div">
                    <img src={url} data-testid="document-preview-img" />
                </DocumentPreview>
            )}
        </>
    );

    const modalHeaderContent = (
        <Header>
            <div>{t('invoiceDocuments.modalViewDocHeader')}</div>
            <DocumentInfo data-testid="document-info" breakpoint={breakpoint}>
                <FileNameDiv data-testid="file-name-div">
                    {filename}
                </FileNameDiv>
            </DocumentInfo>
        </Header>
    );

    return (
        <Modal
            data-testid="view-document-modal"
            bodyContent={modalBodyContent}
            headerContent={customHeaderContent ?? modalHeaderContent}
            id="view-documents-modal"
            onClose={handleClose}
            visible={isViewModalOpen}
            fullScreen={isMobile(breakpoint)}
            modalStyleVariant="gray"
            modalMaxHeight="100vh"
        />
    );
};
export default ViewDocumentModal;
